import React, { useState, Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Card, CardBody, CardTitle, Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import GlideComponent from '../../../../../../components/carousel/GlideComponent';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { putAPI_Update_Response } from '../../../../../../constants/APIs';
import {
  faImages,
  faEdit,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ImgLink from '../ImgLink/ImgLink';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

const BasicCarouselItem = ({ index, url, captions, handleSingleDelete }) => {
  const [isdeleteSingleVisible, setIsdeleteSingleVisible] = useState(false);
  const toggleSingle = () => {
    setIsdeleteSingleVisible(!isdeleteSingleVisible);
  };
  const deleteImage = () => {
    handleSingleDelete(index)
  }


  return (
    <div className="glide-item">
      <Card className="flex-row">
        <div className="w-100 position-relative">
          <img className="card-img-left" src={url} alt={captions[index]} />
          <span
            className={`badge badge-pill badge-primary
                   position-absolute badge-top-left`}
          >
            {captions[index]}
          </span>
          <span
            className={`badge badge-pill
                   position-absolute badge-top-right`} style={{ backgroundColor: 'white', right: '5px' }}
          >
            <FontAwesomeIcon
              icon={faTrashAlt}
              color="#e57373"
              cursor="pointer"
              size="lg"
              onClick={toggleSingle}
            />
          </span>
        </div>

      </Card>
      <Modal isOpen={isdeleteSingleVisible} toggle={toggleSingle}>
        <ModalHeader toggle={toggleSingle}>
          <span role="img" aria-label="warning">
            ⚠️
        </span>
        Image will be deleted!
      </ModalHeader>
        <ModalBody>
          <Button
            color="danger"
            onClick={() => deleteImage()}
            size="xs"
          >
            Delete
        </Button>
          <Button
            className="ml-2"
            color="dark"
            outline
            size="xs"
            onClick={toggleSingle}
          >
            Cancel
        </Button>
        </ModalBody>
      </Modal>
    </div>
  );
};

function ImageCarousel(props) {
  const { reloadBotResponse, code, urls, captions, messages, SaveRecommenderQuestionCode, apiButtons, propertyId, locale } = props;
  const [isEditing, setIsEditing] = useState(false);
  const [isdeleteAllVisible, setIsdeleteAllVisible] = useState(false);
  const toggleAll = () => {
    setIsdeleteAllVisible(!isdeleteAllVisible);
  };
  const [postData, setPostData] = useState({
    GroupId: getGroupID(),
    Code: code,
    Language: `${props.locale === 'en' ? 'en-US' : props.locale}`,
    Channel: 'WebsiteDirectLine',
    PropertyId: props.propertyId,
    Default: null,
    Overrides: {},
  });

  //console.log("buttons", apiButtons)
  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleDelete = () => {
    let data = postData;
    data.Default.Images = []

    try {
      return AxiosAPI({
        method: 'put',
        url: `${putAPI_Update_Response}`,
        data: postData,
      })
        .then(
          setTimeout(() => {
            if (SaveRecommenderQuestionCode !== undefined) {
              SaveRecommenderQuestionCode();
            }
            else {
              reloadBotResponse();
            }
          }, 1000)
        );
    } catch (error) {
      console.error(error);
    }
  };

  const handleSingleDelete = (index) => {
    //TODO:
    let data = postData;
    data.Default.Images.splice(index, 1);

    try {
      return AxiosAPI({
        method: 'put',
        url: `${putAPI_Update_Response}`,
        data: postData,
      })
        .then(
          setTimeout(() => {
            if (SaveRecommenderQuestionCode !== undefined) {
              SaveRecommenderQuestionCode();
            }
            else {
              reloadBotResponse();
            }
          }, 1000)
        );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    let imageList = [];
    setPostData(pre => {
      imageList = urls.map((url, index) => {
        const imgCaption = captions[index];
        return { Url: url, Caption: imgCaption };
      });
      //console.log('imageList', imageList);
      if (apiButtons !== undefined && apiButtons.length > 0) {
        let buttons = [];
        buttons = apiButtons.map((button, index) => {
          return { text: button.query.buttonText, value: button.query.code };
        });
        return {
          ...pre,
          Default: {
            Messages: messages,
            Images: imageList,
            apiButtons: buttons
          },
        };
      }
      else {
        return {
          ...pre,
          Default: {
            Messages: messages,
            Images: imageList
          },
        };
      }
    });
  }, []);

  const Editing = () => {
    return (
      <Fragment>
        {urls.map((url, index) => {
          return (
            <Fragment key={index}>
              <ImgLink
                code={code}
                url={url}
                caption={captions[index]}
                messages={messages}
                urls={urls}
                captions={captions}
                index={index}
                setIsEditingToFalse={() => {
                  setIsEditing(false);
                }}
                reloadBotResponse={reloadBotResponse}
                SaveRecommenderQuestionCode={SaveRecommenderQuestionCode}
              />
            </Fragment>
          );
        })}
      </Fragment>
    );
  };

  const Showing = () => {
    return (
      <Fragment>


        <Card>
          <CardBody>
            <CardTitle>
              <Row>
                <Colxx xxs="8">
                  <FontAwesomeIcon icon={faImages} />
                  <span> </span>
                  <IntlMessages id="property.image-carousel" />
                </Colxx>
                <Colxx xxs="4">
                  <div className="float-right">
                    <FontAwesomeIcon
                      icon={faEdit}
                      color="#90caf9"
                      cursor="pointer"
                      onClick={handleEdit}
                    />
                    <b> | </b>
                    <FontAwesomeIcon
                      icon={faTrashAlt}
                      color="#e57373"
                      cursor="pointer"
                      onClick={toggleAll}
                    />
                  </div>
                </Colxx>
              </Row>
            </CardTitle>
            <Row>
              <Colxx xxs="12" className="pl-0 pr-0 mb-0">
                {/* make sure you always use GlideComponent and BasicCarouselItem together.
                Otherwise, It will cause your program to stop working, but you won't get any debug information. It can even make you think your browser is broken.
              */}
                <GlideComponent
                  settings={{
                    gap: 5,
                    perView: 3,
                    keyboard: false,
                    // type: 'slider',
                    rewind: false,
                    // breakpoints: {
                    //   600: { perView: 1 },
                    //   1400: { perView: 2 },
                    // },
                  }}
                >
                  {urls.map((url, index) => {
                    return (
                      <div key={index}>
                        <BasicCarouselItem
                          index={index}
                          url={url}
                          captions={captions}
                          handleSingleDelete={handleSingleDelete}
                        />
                      </div>
                    );
                  })}
                </GlideComponent>
              </Colxx>
            </Row>

            {isEditing ? Editing() : null}
          </CardBody>
        </Card>
        <Modal isOpen={isdeleteAllVisible} toggle={toggleAll}>
          <ModalHeader toggle={toggleAll}>
            <span role="img" aria-label="warning">
              ⚠️
        </span>
        All images will be deleted!
      </ModalHeader>
          <ModalBody>
            <Button
              color="danger"
              onClick={() => handleDelete()}
              size="xs"
            >
              Delete
        </Button>
            <Button
              className="ml-2"
              color="dark"
              outline
              size="xs"
              onClick={toggleAll}
            >
              Cancel
        </Button>
          </ModalBody>
        </Modal>
      </Fragment>
    );
  };

  return <Fragment>{Showing()}</Fragment>;
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId, locale
  };
};
export default injectIntl(connect(mapStateToProps)(ImageCarousel));
ImageCarousel.propTypes = {
  code: PropTypes.string.isRequired,
  urls: PropTypes.array,
  captions: PropTypes.array,
  index: PropTypes.number,
};
